import type { CSSProperties } from 'react';
import type { Components } from 'react-markdown';

const baseHeading: CSSProperties = { margin: 0, textTransform: 'none' };

const h1Style: CSSProperties = { ...baseHeading, fontSize: '1.2rem', fontWeight: 700 };
const h2Style: CSSProperties = { ...baseHeading, fontSize: '1.1rem', fontWeight: 700 };
const h3Style: CSSProperties = { ...baseHeading, fontSize: '1.05rem', fontWeight: 600 };
const h4Style: CSSProperties = { ...baseHeading, fontSize: '1rem', fontWeight: 600 };
const h5Style: CSSProperties = { ...baseHeading, fontSize: '0.95rem', fontWeight: 600 };
const h6Style: CSSProperties = { ...baseHeading, fontSize: '0.9rem', fontWeight: 600 };

export const AiSummaryMarkdownComponents: Components = {
  p: 'div',
  h1: ({ children }) => <div style={h1Style}>{children}</div>,
  h2: ({ children }) => <div style={h2Style}>{children}</div>,
  h3: ({ children }) => <div style={h3Style}>{children}</div>,
  h4: ({ children }) => <div style={h4Style}>{children}</div>,
  h5: ({ children }) => <div style={h5Style}>{children}</div>,
  h6: ({ children }) => <div style={h6Style}>{children}</div>
};
